export const IconActivity = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.6 8.2C0.434315 8.42091 0.479086 8.73431 0.7 8.9C0.920914 9.06569 1.23431 9.02091 1.4 8.8L0.6 8.2ZM4 4.5L4.35355 4.14645C4.25106 4.04395 4.10914 3.99098 3.96456 4.00126C3.81997 4.01153 3.68697 4.08404 3.6 4.2L4 4.5ZM6.5 7L6.14645 7.35355C6.24786 7.45496 6.38793 7.50795 6.53107 7.49903C6.67421 7.49012 6.80663 7.42018 6.89468 7.30697L6.5 7ZM10.3947 2.80697C10.5642 2.589 10.5249 2.27486 10.307 2.10532C10.089 1.93579 9.77486 1.97506 9.60532 2.19303L10.3947 2.80697ZM1.4 8.8L4.4 4.8L3.6 4.2L0.6 8.2L1.4 8.8ZM3.64645 4.85355L6.14645 7.35355L6.85355 6.64645L4.35355 4.14645L3.64645 4.85355ZM6.89468 7.30697L10.3947 2.80697L9.60532 2.19303L6.10532 6.69303L6.89468 7.30697Z" />
  </svg>
);

export const IconQuestion = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="3" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8ZM6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9Z"
      fill="#838282"
    />
  </svg>
);
